import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/user/balancelog/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/user/balancelog/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/user/balancelog/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/user/balancelog/submit',
    method: 'post',
    data: row
  })
}

